import React from "react";

export default props => {
  const { width = 18, color, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      className={className}
      width={width}
    >
      <path
        d="M42.595 0h-25.19A4.411 4.411 0 0 0 13 4.405v51.189A4.411 4.411 0 0 0 17.405 60h25.189A4.411 4.411 0 0 0 47 55.595V4.405A4.411 4.411 0 0 0 42.595 0zM15 8h30v38H15V8zm2.405-6h25.189A2.408 2.408 0 0 1 45 4.405V6H15V4.405A2.408 2.408 0 0 1 17.405 2zm25.19 56h-25.19A2.408 2.408 0 0 1 15 55.595V48h30v7.595A2.408 2.408 0 0 1 42.595 58z"
        fill={color || "currentColor"}
      />
      <path
        d="M30 49c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zM26 5h4a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2zM33 5h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2zM56.612 4.569a.999.999 0 1 0-1.414 1.414c3.736 3.736 3.736 9.815 0 13.552a.999.999 0 1 0 1.414 1.414c4.516-4.515 4.516-11.864 0-16.38z"
        fill={color || "currentColor"}
      />
      <path
        d="M52.401 6.845a.999.999 0 1 0-1.414 1.414c1.237 1.237 1.918 2.885 1.918 4.639s-.681 3.401-1.918 4.638a.999.999 0 1 0 1.414 1.414c1.615-1.614 2.504-3.764 2.504-6.052s-.888-4.439-2.504-6.053zM4.802 5.983a.999.999 0 1 0-1.414-1.414c-4.516 4.516-4.516 11.864 0 16.38a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414c-3.737-3.736-3.737-9.815 0-13.552z"
        fill={color || "currentColor"}
      />
      <path
        d="M9.013 6.569a.999.999 0 0 0-1.414 0c-1.615 1.614-2.504 3.764-2.504 6.052s.889 4.438 2.504 6.053a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414c-1.237-1.237-1.918-2.885-1.918-4.639s.68-3.401 1.918-4.638a1 1 0 0 0 0-1.414z"
        fill={color || "currentColor"}
      />
    </svg>
  );
};
